import React from "react";
import Toaster from "../Toaster";
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from "../CclDataTable";
import SystemEmailTemplate from "../../code/models/SystemEmailTemplate";
import ApiSystemEmailTemplates from "../../code/api/ApiSystemEmailTemplates";
import "../../css/adminemailtemplates.css";
import EmailEditor from "../emaileditor/EmailEditor";
import TemplateTag from "../../code/models/TemplateTag";
import ApiEmailTemplates from "../../code/api/ApiEmailTemplates";

export default function AdminSystemEmailTemplates() {
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [templates, setTemplates] = React.useState<SystemEmailTemplate[]>([]);
    const [selectedTemplate, setSelectedTemplate] = React.useState<SystemEmailTemplate | null>(null);
    const [editTemplate, setEditTemplate] = React.useState<SystemEmailTemplate | null>(null);
    const [anyChanges, setAnyChanges] = React.useState<boolean>(false);
    const [templateTags, setTemplateTags] = React.useState<TemplateTag[]>([]);

    React.useEffect(() => {
        ApiEmailTemplates.getTemplateTags().then((tags) => {
            setTemplateTags(tags);
            loadTemplates();
        });
    }, []);

    async function loadTemplates() {
        setSelectedTemplate(null);
        setEditTemplate(null);
        setAnyChanges(false);
        ApiSystemEmailTemplates.getEmailTemplates().then((temps) => {
            setTemplates(temps);
        });
    }

    function rowSelected(rowData: SystemEmailTemplate): void {
        setSelectedTemplate(rowData);
        setEditTemplate(structuredClone(rowData));
        setAnyChanges(false);
    }

    function emailEditorTextChanged(newText: string) {
        if (editTemplate !== null) {
            editTemplate.template = newText;
        }

        checkHasChanges();
    }

    function checkHasChanges() {
        var isAnyChanges = editTemplate !== null &&
            selectedTemplate !== null &&
            (selectedTemplate.name !== editTemplate.name ||
                selectedTemplate.subject !== editTemplate.subject ||
                selectedTemplate.template !== editTemplate.template ||
                selectedTemplate.sendGridTemplateId !== editTemplate.sendGridTemplateId);
        setAnyChanges(isAnyChanges);
    }

    const bplColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "name",
            title: "Templates",
            visible: true,
            type: CclDataTableColumnType.Data
        }
    ];

    function saveTemplateClick(): void {
        if (anyChanges && !!editTemplate && !!selectedTemplate) {
            ApiSystemEmailTemplates.saveEmailTemplate(editTemplate).then((savedTempl) => {
                if (!!savedTempl) {
                    selectedTemplate.companyId = savedTempl.companyId;
                    selectedTemplate.subject = savedTempl.subject;
                    selectedTemplate.template = savedTempl.template;

                    showMessage(`Email temaplate "${editTemplate.name}" saved.`);
                    rowSelected(selectedTemplate);
                }
            });
        }
    }

    function showMessage(message: string) {
        setToastMessage(message);
        setTimeout(() => { setToastMessage(""); }, 8000);
    }


    return (
        <React.Fragment>
            <div className="emmailtemplates-main">
                <div className="emailtemplates-left">
                    <div className="emmailtemplates-table-wrapper">
                        <CclDataTable
                            name={"profilesTable"}
                            tableData={templates || []}
                            columnDefinitions={bplColumnDefs}
                            onRowSelect={rowSelected}
                            rowSelect={true}
                            onButtonClick={null} />
                    </div>
                </div>
                <div className="emailtemplates-right" key={"et-edit-" + (selectedTemplate?.systemEmailTemplateId || "a")}>
                    <div className="row emailtemplates-editortop">
                        <div className="col-md-4">
                            <label htmlFor="templateSubject" className="form-label">Subject</label>
                            <input className="form-control" disabled={!editTemplate}
                                id="templateSubject" defaultValue={selectedTemplate?.subject} autoComplete={"off"}
                                onChange={(e) => {
                                    if (!!editTemplate) {
                                        editTemplate.subject = e.target.value;
                                        checkHasChanges();
                                    }
                                }}></input>
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="templateSendgridId" className="form-label text-nowrap">SendGrid Id</label>
                            <input className="form-control" disabled={!editTemplate}
                                id="templateSendgridId" defaultValue={selectedTemplate?.sendGridTemplateId} autoComplete={"off"}
                                onChange={(e) => {
                                    if (!!editTemplate) {
                                        editTemplate.sendGridTemplateId = e.target.value;
                                        checkHasChanges();
                                    }
                                }}></input>
                        </div>
                        <div className="col-md-1 emailtemplates-save text-nowrap">
                            <button className={"btn btn-sm " + (!editTemplate ? "btn-outline-secondary" : "btn-primary")}
                                disabled={!editTemplate || !anyChanges} onClick={saveTemplateClick} >Save Template</button>
                        </div>
                    </div>
                    <div className="row emailtemplates-editormain">
                        {!!editTemplate &&
                            <EmailEditor initialValue={editTemplate.template} onChange={(newText) => emailEditorTextChanged(newText)}
                                templateTags={templateTags} previewMode={false} />
                        }
                    </div>
                </div>
            </div>
            <Toaster title="Email Templates" subtitle="Email" message={toastMessage} key={"emailtemplatetoast"} />
        </React.Fragment>
    )
}
